import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class BlockTeam {

	static init() {

		ScrollTrigger.batch(".team-member .image", {
			onEnter: elements => {
				gsap.to(elements, {
					'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
					stagger: 0.15
				});
			},
			start: "top 85%",
			once: true
		});

	}

}
